import { render, staticRenderFns } from "./FamilyMember.vue?vue&type=template&id=f2a967b0&"
import script from "./FamilyMember.vue?vue&type=script&lang=js&"
export * from "./FamilyMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports